import { render } from "./PrcHandleOld.vue?vue&type=template&id=5253d830&scoped=true"
import script from "./PrcHandleOld.vue?vue&type=script&lang=js"
export * from "./PrcHandleOld.vue?vue&type=script&lang=js"

import "./PrcHandleOld.vue?vue&type=style&index=0&id=5253d830&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5253d830"]])

export default __exports__